import { render } from "./FeatureSection.vue?vue&type=template&id=00429a09"
import script from "./FeatureSection.vue?vue&type=script&lang=ts"
export * from "./FeatureSection.vue?vue&type=script&lang=ts"
script.render = render

export default script